import * as R from 'ramda';
import React from 'react';
import { node } from 'prop-types';
import classnames from 'classnames';
import { PublicError } from 'common/service/error';

const displayError = (error) => {
  if (R.is(PublicError, error)) {
    return error.title;
  }

  if (R.is(String, error)) {
    return error;
  }

  return error;
};

const Error = ({ className, children }) => (
  <div
    className={classnames(
      'mdc-form-error',
      className,
    )}
  >{displayError(children)}
  </div>
);

Error.propTypes = {
  children: node.isRequired,
};

export default Error;
